import React from "react";
import useStockTickerData from "../../../hooks/useStockTickerData";
import { ToolNavigationItem } from "../../../models/navigation/ToolNavigationItem";
import SanityLink from "../../SanityLink";

interface Props extends ToolNavigationItem {
  fontClass: string;
}

export const StockTickerToolLink = (props: Props) => {
  const { fontClass, transparentBackground } = props;

  const tickerBackgroundClass = `bg-brand-primary-${transparentBackground ? "70" : "50"}`;
  const stockTicker = useStockTickerData();

  if (!stockTicker?.length) {
    return null;
  }

  const [stockTickerData] = stockTicker;

  if (!stockTickerData?.tickers?.length) {
    return null;
  }

  const ticker = stockTickerData?.tickers[0];

  return (
    <SanityLink
      className={`${fontClass} inline-flex justify-between items-center text-inherit font-bold no-underline focus:shadow-outline focus:outline-none`}
    >
      <span>
        {ticker?.price} {ticker?.tradeCurrency}
      </span>
      <span
        className={`${tickerBackgroundClass} px-2 py-1 ml-2 text-xs text-white rounded`}
      >
        {ticker?.deltaPercentage && ticker.deltaPercentage >= 0 ? "+" : ""}{" "}
        {ticker?.deltaPercentage?.toFixed(2)}%
      </span>
    </SanityLink>
  );
};
